import React from "react";
import MarketsAttention from "../GlobalDashboard/MarketsAttention";
import StoresAttention from "../market/StoresAttention";

/**
 * The panel beside the trend chart.
 *
 * Global gets the market league table; a market gets its own worst stores.
 * The conditional had been commented out so both views rendered the market
 * table — harmless while it held a static array, but once it became the live
 * global roll-up a market page was showing every other market's numbers.
 */
const MarketsOrStoresPanel = ({ mode, accountId }) =>
  mode === "market" && accountId ? (
    <StoresAttention accountId={accountId} />
  ) : (
    <MarketsAttention accountId={accountId} mode={mode} />
  );

export default MarketsOrStoresPanel;
